export type MembershipLocation = { address?: string | null; addressLine1?: string | null; addressLine2?: string | null; city?: string | null; state?: string | null; postalCode?: string | null };

export function membershipAddress(record: MembershipLocation) {
 return [record.addressLine1 || record.address, record.addressLine2, record.city, [record.state, record.postalCode].filter(Boolean).join(' ')].filter(Boolean).join(', ');
}

export function isPriorMembershipTerm(record: { status?: string; displayStatus?: string; renewedIntoId?: string | null }) {
 return Boolean(record.renewedIntoId) || (record.displayStatus || record.status || '').toLowerCase() === 'renewed';
}

export function isCurrentOrUpcomingMembership(record: { status: string; displayStatus?: string; startDate?: string | null; endDate?: string | null }, today: string) {
 const status = (record.displayStatus || record.status).toLowerCase();
 if (!["active", "renewal", "upcoming"].includes(status)) return false;
 return !record.endDate || record.endDate.slice(0, 10) >= today;
}

export function locationMembershipStatus(records: Array<{ status: string; displayStatus?: string; startDate?: string | null; endDate?: string | null }>, today: string): { label: string; state: "active" | "upcoming" | "expired" | "inactive" | "none" } {
 const current = records.filter(record => isCurrentOrUpcomingMembership(record, today));
 if (current.some(record => !record.startDate || record.startDate.slice(0, 10) <= today)) return { label: "Active membership", state: "active" };
 if (current.length) return { label: "Upcoming membership", state: "upcoming" };
 if (!records.length) return { label: "No membership", state: "none" };
 const latest = [...records].sort((a,b) => (b.endDate || b.startDate || "").localeCompare(a.endDate || a.startDate || ""))[0];
 const status = (latest.displayStatus || latest.status).toLowerCase();
 if (["inactive", "canceled", "cancelled", "paused", "suspended"].includes(status)) return { label: "Inactive membership", state: "inactive" };
 return { label: "Expired membership", state: "expired" };
}
